import React, { useState } from "react";
import { Page, Block, BlockTitle, Button } from "framework7-react";
import AppNavbar from "modules/1_layout/mobile/AppNavbar";
import { isNativeApp, takePhoto } from "modules/native";

import { ActionSheet, ActionSheetButtonStyle } from '@capacitor/action-sheet';

const Home = () => {
  return (
    <Page>
      <AppNavbar title="Lion V3" />
      <Block>Welcome to LionV3 Mobile App, please use the menu on the left</Block>
    </Page>
  );
};

export default Home;
